var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteUserHighlighted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5856",
    "data-name": "Rectangle 5856",
    width: 16.972,
    height: 20.892,
    fill: "#505465"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Download-highlighted",
    transform: "translate(-1793 -282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21152",
    "data-name": "Group 21152",
    transform: "translate(1793 282)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_896",
    "data-name": "Ellipse 896",
    cx: 19,
    cy: 19,
    r: 19,
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21067",
    "data-name": "Group 21067",
    transform: "translate(1803.966 290.454)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21049",
    "data-name": "Group 21049",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9912",
    "data-name": "Path 9912",
    d: "M20.272,91.972h6.85c.572,0,.58,0,.555.552q-.25,5.437-.509,10.873A1.953,1.953,0,0,1,25.1,105.35q-4.852.006-9.7,0a1.956,1.956,0,0,1-2.065-1.961c-.176-3.638-.337-7.276-.518-10.913-.02-.393.089-.516.49-.513,2.324.017,4.648.008,6.972.008m-2.635,5.874q0-2.039,0-4.079c0-.514-.244-.813-.651-.813s-.651.3-.651.812q0,4.079,0,8.157c0,.514.244.813.651.813s.65-.3.651-.813q0-2.039,0-4.079m1.96,0q0,2.039,0,4.079c0,.513.245.813.651.813s.65-.3.651-.814q0-4.079,0-8.157c0-.514-.245-.813-.652-.812s-.649.3-.65.813q0,2.039,0,4.079m4.566.008c0-1.4,0-2.8,0-4.2a.648.648,0,0,0-.641-.7.64.64,0,0,0-.656.682c-.006,2.8-.009,5.6.01,8.4a.787.787,0,0,0,.3.571.692.692,0,0,0,.628.027.891.891,0,0,0,.348-.622c.031-1.386.016-2.773.015-4.16",
    transform: "translate(-11.763 -84.461)",
    fill: "#505465"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9913",
    "data-name": "Path 9913",
    d: "M5.223,2.616c0-.253,0-.467,0-.68A1.95,1.95,0,0,1,7.15.01C8.007-.006,8.863,0,9.72.007a1.957,1.957,0,0,1,2.029,2.032c0,.175,0,.35,0,.558.155.007.285.019.416.019,1.047,0,2.094-.006,3.14,0a1.622,1.622,0,0,1,1.663,1.644c.007.353,0,.707,0,1.06,0,.672-.208.883-.869.884q-2.569,0-5.139,0H.93C.188,6.207,0,6.016,0,5.261,0,4.975,0,4.69,0,4.4A1.647,1.647,0,0,1,1.809,2.616q1.489,0,2.977,0ZM6.53,2.589h3.911c0-.228.011-.43,0-.631a.633.633,0,0,0-.652-.64q-1.3-.019-2.6,0a.635.635,0,0,0-.654.639c-.013.2,0,.4,0,.633",
    transform: "translate(0 0)",
    fill: "#505465"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteUserHighlighted);
export default __webpack_public_path__ + "static/media/DeleteUser-highlighted.b0e3e76e628fe5aac67476bf63b68d4d.svg";
export { ForwardRef as ReactComponent };